"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TasksGlobalFilterBody = TasksGlobalFilterBody;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const ContractContext_1 = require("../Contracts/ContractsList/ContractContext");
const MainSetupReact_1 = __importDefault(require("../React/MainSetupReact"));
const RepositoryReact_1 = __importDefault(require("../React/RepositoryReact"));
const BussinesObjectSelectors_1 = require("../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const FormContext_1 = require("../View/Modals/FormContext");
const StatusSelectors_1 = require("../View/Modals/CommonFormComponents/StatusSelectors");
const CaseStatusFilter_1 = require("../View/Modals/CommonFormComponents/CaseStatusFilter");
function TasksGlobalFilterBody() {
    const { project } = (0, ContractContext_1.useContract)();
    const { watch, setValue } = (0, FormContext_1.useFormContext)();
    const _contract = watch("_contract");
    const caseStatuses = watch("caseStatuses");
    const taskStatuses = watch("taskStatuses");
    // Domyślne filtry statusów. Ustawiamy tylko gdy pole jest jeszcze puste — snapshot
    // z sessionStorage (przywracany w FilterPanel) ma pierwszeństwo.
    // - Sprawy: Na zaś + W trakcie (ukrywa Zamknięte).
    // - Zadania: wszystkie statusy (brak filtrowania zadań domyślnie).
    (0, react_1.useEffect)(() => {
        if (caseStatuses === undefined)
            setValue("caseStatuses", [...CaseStatusFilter_1.DEFAULT_CASE_STATUS_FILTER]);
        if (taskStatuses === undefined)
            setValue("taskStatuses", Object.values(MainSetupReact_1.default.TaskStatus));
    }, []);
    const casesFilterRepository = (0, react_1.useMemo)(() => new RepositoryReact_1.default({
        actionRoutes: { getRoute: "cases", addNewRoute: "", editRoute: "", deleteRoute: "" },
        name: "tasksCasesSelectorFilter_temp",
    }), []);
    (0, react_1.useEffect)(() => {
        setValue("_case", undefined);
    }, [_contract?.id]);
    return (react_1.default.createElement(react_bootstrap_1.Row, null,
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 6, controlId: "_contract" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Kontrakt"),
            react_1.default.createElement(BussinesObjectSelectors_1.ContractSelector, { showValidationInfo: false, _project: project })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 3, controlId: "_owner" },
            react_1.default.createElement(BussinesObjectSelectors_1.PersonSelectorPreloaded, { showValidationInfo: false, repository: MainSetupReact_1.default.personsEnviRepository, name: "_owner", label: "W\u0142a\u015Bciciel" })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 3 },
            react_1.default.createElement(StatusSelectors_1.ContractStatusSelector, { showValidationInfo: false, multiple: true, label: "Statusy kontraktu" })),
        _contract && (react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 12, className: "mt-2" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Sprawa"),
            react_1.default.createElement(BussinesObjectSelectors_1.CaseSelectMenuElement, { name: "_case", repository: casesFilterRepository, showValidationInfo: false, _contract: _contract, multiple: false }))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 3 },
            react_1.default.createElement(StatusSelectors_1.CaseStatusSelector, { showValidationInfo: false, multiple: true, name: "caseStatuses", label: "Statusy spraw" })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 9 },
            react_1.default.createElement(StatusSelectors_1.TaksStatusSelector, { showValidationInfo: false, multiple: true, name: "taskStatuses", label: "Statusy zada\u0144" }))));
}
